import xquery from "refractor/xquery";
export default xquery;